import type { TaxonomyListSummary } from '@/entities/taxonomy-list';
import { resolveBoundColumnPair } from '@inference.engine/taxonomy/web';

/** The field's own list stays pickable even when it no longer binds, so opening a form cannot hide it. */
export function isBindableList(
  list: Pick<TaxonomyListSummary, 'id' | 'boundColumns'>,
  ownListId?: string,
): boolean {
  return list.id === ownListId || !!resolveBoundColumnPair(list.boundColumns);
}
